{
  "name": "@uppy/webcam",
  "description": "Uppy plugin that takes photos or records videos using the device's camera.",
  "version": "6.0.1",
  "license": "MIT",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "webcam",
    "picture",
    "photo",
    "video",
    "record",
    "mediarecorder"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.css": "./dist/style.css",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.scss": "./src/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "is-mobile": "^5.0.0",
    "preact": "^10.29.2"
  },
  "devDependencies": {
    "@uppy-dev/tsconfig": "workspace:^",
    "@vitest/browser-playwright": "^4.1.11",
    "cssnano": "^8.0.1",
    "playwright": "1.61.1",
    "postcss": "^8.5.23",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^6.0.3",
    "vitest": "^4.1.11"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  }
}
